module.exports = __webpack_public_path__ + "static/img/Createacomb.c6cd2808.svg";